import React from "react";

export default React.createContext({
  lg: 4,
  sm: 6,
  xs: 12,
});
